var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
function fetchAdapter(config) {
  return __async(this, null, function* () {
    const request = createRequest(config);
    const promiseChain = [getResponse(request, config)];
    let timer = null;
    if (config.timeout && config.timeout > 0) {
      promiseChain.push(
        new Promise((_, reject) => {
          timer = setTimeout(() => {
            const message = config.timeoutErrorMessage ? config.timeoutErrorMessage : "timeout of " + config.timeout + "ms exceeded";
            reject(createError(message, config, "ETIMEDOUT", request));
          }, config.timeout);
        })
      );
    }
    const response = yield Promise.race(promiseChain);
    if (timer !== null) {
      clearTimeout(timer);
    }
    return new Promise((resolve, reject) => {
      if (response instanceof Error) {
        reject(response);
      } else {
        const validateStatus = config.validateStatus;
        if (!response.status || !validateStatus || validateStatus(response.status)) {
          resolve(response);
        } else {
          reject(
            createError(
              "Request failed with status code " + response.status,
              config,
              getErrorCodeFromStatus(response.status),
              request,
              response
            )
          );
        }
      }
    });
  });
}
function getResponse(request, config) {
  return __async(this, null, function* () {
    let stageOne;
    try {
      stageOne = yield fetch(request);
    } catch (e) {
      return createError("Network Error", config, "ERR_NETWORK", request);
    }
    const headers = Object.assign({}, stageOne.headers);
    const response = {
      status: stageOne.status,
      statusText: stageOne.statusText,
      headers,
      config,
      request,
      data: void 0
    };
    if (stageOne.status >= 200 && stageOne.status !== 204) {
      switch (config.responseType) {
        case "arraybuffer":
          response.data = yield stageOne.arrayBuffer();
          break;
        case "blob":
          response.data = yield stageOne.blob();
          break;
        case "json":
          response.data = yield stageOne.json();
          break;
        default:
          response.data = yield stageOne.text();
          break;
      }
    }
    return __spreadProps(__spreadValues({}, response), { ok: stageOne.ok });
  });
}
function createRequest(config) {
  const headers = new Headers(config.headers);
  if (config.auth) {
    const username = config.auth.username || "";
    const password = config.auth.password ? decodeURI(encodeURIComponent(config.auth.password)) : "";
    headers.set(
      "Authorization",
      `Basic ${Buffer.from(username + ":" + password).toString("base64")}`
    );
  }
  if (config.method === void 0) {
    config.method = "get";
  }
  const method = config.method.toUpperCase();
  const options = { headers, method };
  if (method !== "GET" && method !== "HEAD") {
    options.body = config.data;
  }
  if (config.withCredentials !== void 0) {
    options.credentials = config.withCredentials ? "include" : "omit";
  }
  const url = buildFullPath(config.url ? config.url : "", config.baseURL);
  return new Request(url, options);
}
function createError(message, config, code, request, response) {
  const error = new Error(message);
  error.config = config;
  error.code = code;
  error.request = request;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
}
function getErrorCodeFromStatus(status) {
  return ["ERR_BAD_REQUEST", "ERR_BAD_RESPONSE"][Math.floor(status / 100) - 4] || "ERR_BAD_OPTION";
}
function buildFullPath(requestedURL, baseURL) {
  if (requestedURL && baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  if (!requestedURL && baseURL) {
    return baseURL;
  }
  return requestedURL;
}
function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "");
}
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
export {
  fetchAdapter as default
};
